import React, { useEffect, useState } from 'react'
import CookieConsent from 'react-cookie-consent';


export default function Cookie({currentProject, darkMode}) {
    
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [showPopUp, setShowPopUp] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
          const scrolled = window.scrollY;
          if (scrolled > 100) {
            setShowPopUp(true);
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            {showPopUp ? (
            <CookieConsent
            location="bottom"
            buttonText="Accept"
            cookieName="meuCookieConsent"
                style={{
                background: '#ffffff',
                opacity: currentProject || darkMode  ? '0' : '1' ,
                color: '#4d4d4d',
                position: 'fixed',
                bottom: '20px', 
                left: '20px', 
                maxWidth: '350px', 
                padding: '10px', 
                borderRadius: '5px', 
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center', 
                alignItems: 'center', 
                marginLeft: '0.5em',
                marginBottom: '4em',
                zIndex: '1050',
                ...(windowWidth <= 730 && {
                    maxWidth: '100%',
                    marginBottom: '0',
                    left: 0,
                    marginLeft: '0',
                }),
                ...(windowWidth <= 480 && {
                    maxWidth: '100%',
                    marginBottom: '0',
                    left: 0,
                    marginLeft: '0',
                }),
                ...(windowWidth <= 320 && {
                    maxWidth: '100%',
                    marginRight: '0',
                    marginLeft: '0',
                }),
                }}
            buttonStyle={{ 
                background: '#4d4d4d', 
                color: '#ffffff',
                border: 'none', 
                padding: '8px 125px',
                marginRight: '20px',
                borderRadius: '3px', 
                cursor: 'pointer', 
                textAlign: 'center',
                fontWeight: '600',
                ...(windowWidth <= 320 && {
                    padding: '8px 110px',
                    fontSize: '10px'
                }),  
            }}
            expires={150}
        >
            <p style={{ fontSize: '17px', marginBottom: '12px', fontFamily: 'Lora, serif', color: '#202020', fontWeight: '700',
                ...(windowWidth <= 320 && {
                    fontSize: '14px',
                    marginLeft: '1.3em',
                    marginRight: '2em'
                }), }}
                >We value your privacy
            </p>

            <p style={{ fontSize: '12px', margin: '0', color: '#606060',
                ...(windowWidth <= 320 && {
                    fontSize: '10px',
                    margin:'0 2em'
                }), }}
                >This website uses cookies to offer users a better experience. By continuing to use this website, you agree to the use of cookies.
            </p>
        </CookieConsent>
        ) : null}
        </div>
    )
    }
